import { Checkbox, Collapse } from "antd";
import { FC } from "react";

import { StyledCheckboxGroup } from "./AutoGeneratedFilters.styled";

interface AutoGeneratedFiltersProps {
    availableFilters: Record<
        string,
        { title: string; options: (string | number | boolean)[] }
    >;
    selectedFilters: Record<string, (string | number | boolean)[]>;
    onFilterChange: (
        tag: string,
        values: (string | number | boolean)[],
    ) => void;
}

export const AutoGeneratedFilters: FC<AutoGeneratedFiltersProps> = ({
    availableFilters,
    selectedFilters,
    onFilterChange,
}) => {
    const formatValue = (value: string | number | boolean) => {
        if (typeof value === "boolean") {
            return value ? "Так" : "Ні";
        }
        return String(value);
    };

    return (
        <Collapse destroyOnHidden={false}>
            {Object.entries(availableFilters).map(
                ([tag, { title, options }]) => (
                    <Collapse.Panel header={title} key={tag}>
                        <StyledCheckboxGroup
                            value={selectedFilters[tag] || []}
                            onChange={(values: (string | number | boolean)[]) =>
                                onFilterChange(tag, values)
                            }
                        >
                            {options.map((option) => (
                                <Checkbox key={String(option)} value={option}>
                                    {formatValue(option)}
                                </Checkbox>
                            ))}
                        </StyledCheckboxGroup>
                    </Collapse.Panel>
                ),
            )}
        </Collapse>
    );
};
